<template>
    <div>
        
        <v-tabs background-color="warning accent-4" center-active dark v-model="selectedTab">
            <v-tab v-if="get_archive.date">
                {{ formated_date(get_archive.date) }}
            </v-tab>
            <v-tab>
                <v-btn text color="white" dark @click="$router.push('/archive') ">
                    Календарь
                </v-btn>
            </v-tab>
        </v-tabs>
        <div v-if="!get_archive.date">
            Смена еще закрыта или не создана
        </div>
        <div class="statistic">
            <div class="products">
                <template v-if="get_archive.date">
                    <h2>Статистика на {{ formated_date(get_archive.date) }} г.</h2>
                </template>
                <div class="products_list">
                    <template v-if="title == 'admin' && get_archive && get_archive.date">
                        <v-btn color="warning" class="mb-4" @click="open(get_archive._id)"> Открыть смену </v-btn>
                    </template>
                    <div class="groups-grid">
                        
                          
                            <ProductGroup
                                v-for="group in get_archive.groups"
                                :key="group._id"
                                :group="group"
                                :small="true"
                                :plan="null"
                                :fact="null"
                                :input="true"
                            />
                        
                    </div>
                </div>
                <div class="totals" v-if="get_archive && get_archive.date">
                    <h2>Итоги дня</h2>
                    <div class="d-flex">
                        <div class="total_item">
                            <h3>Продукция</h3>
                            <div class="accessory">
                                <div class="plan_fact">
                                    <template v-if="get_archive && get_archive.totals">
                                        <template v-if="get_archive.totals.total_product_fact >= get_archive.totals.total_product_plan">
                                            <span class="fact fact--green">{{ get_archive.totals.total_product_fact || 0 }}</span>
                                            /
                                            <span class="plan">{{ get_archive.totals.total_product_plan || 0 }}</span>
                                        </template>
                                        <template v-else>
                                            <span class="fact fact--red">{{ get_archive.totals.total_product_fact || 0 }}</span>
                                            /
                                            <span class="plan">{{ get_archive.totals.total_product_plan || 0 }}</span>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="total_item">
                            <h3>ДПФ</h3>
                            <div class="accessory">
                                <div class="plan_fact">
                                    <span class="fact fact--green">{{ get_archive && get_archive.totals  ? get_archive.totals.dpf : 0 }} руб.</span>
                                </div>
                            </div>
                        </div>
                        <div class="total_item">
                            <h3>% вып-ния</h3>
                            <div class="accessory">
                                <div class="plan_fact">
                                    <template v-if="get_archive.totals && get_archive.totals">
                                        <span class="fact fact--green">{{  get_archive.totals.middle_percent || 0  }} %</span>
                                    </template>
                                    <template v-else>
                                        <span class="fact fact--green">0.00 %</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="totals" v-if="get_archive && get_archive.date">
                    <h2>Итоги месяца по выбранной дате</h2>
                    <div class="d-flex">
                        <div class="total_item">
                            <h3>Продукция</h3>
                            <div class="accessory">
                                <div class="plan_fact">
                                    <template v-if="get_totals_month.fact >= get_totals_month.plan">
                                        <span class="fact fact--green">{{ get_totals_month.fact || 0 }}</span>
                                        /
                                        <span class="plan">{{ get_totals_month.plan || 0 }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="fact fact--red">{{ get_totals_month.fact || 0 }}</span>
                                        /
                                        <span class="plan">{{ get_totals_month.plan || 0 }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="total_item">
                            <h3>ДПФ</h3>
                            <div class="accessory">
                                <div class="plan_fact">
                                    <!-- <span class="fact fact--green">{{ +dpf_amount_month.toFixed(2) || 0 }} руб.</span> -->
                                    <span class="fact fact--green">{{ +get_totals_month.dpf.toFixed(2) || 0 }} руб.</span>
                                </div>
                            </div>
                        </div>
                        <div class="total_item">
                            <h3>% вып-ния</h3>
                            <div class="accessory">
                                <div class="plan_fact">
                                    <template v-if="get_totals_month && get_totals_month.percent">
                                        <!-- <span class="fact fact--green">{{ percent_amount_month.toFixed(2) }} %</span> -->
                                        <span class="fact fact--green">{{ get_totals_month.percent }} %</span>
                                    </template>
                                    <template v-else>
                                        <span class="fact fact--green">0.00 %</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ProductGroup from '@/components/products/ProductGroup.vue'

export default {
    name: 'Archive',
    components: {
        ProductGroup,
    },
    data() {
        return {
            selectedTab: null,
            plan_amount_month: null,
            fact_amount_month: null,
            dpf_amount_month: null,
            percent_amount_month: null,
            products: null,
            products_2: null,
            error_text: null,
            product_plan: null,
            product_fact: null,
            DPF: null,
            percent: null,
            current_date: null,
            id: null,
            title: localStorage.getItem('title'),
        }
    },
    beforeMount() {
        
        this.load_archive({date: this.$route.params.date})
    },
    computed: {
        ...mapGetters(['get_archive', 'get_totals_month']),
        archive() {
            const arch = JSON.parse(JSON.stringify(this.get_archive))

            this.plan_amount_month = 0
            this.fact_amount_month = 0
            this.dpf_amount_month = 0
            this.percent_amount_month = 0
            let arr = []
            console.log(arch);
            // if (arch.date) {
            //     if (!this.id) {
            //         console.log('rtr')
            //         arr.push(arch[arch.length - 1])
            //         this.current_date = arch.date
            //         this.filter(arch[arch.length - 1])
            //         this.id = arch[arch.length - 1]._id
            //     } else {
            //         let archive = arch.find((arr) => arr._id == this.id)

            //         if (!archive) {
            //             archive = arch[arch.length - 1]
            //             this.id = archive._id
            //         }
            //         arr.push(archive)
            //         this.current_date = archive.date
            //         this.filter(archive)
            //     }

            //     const current_date = new Date()
            //     const current_month = current_date.getMonth()
            //     const current_year = current_date.getFullYear()
            //     arch.forEach((a) => {
            //         const stat_date = new Date(a.date)
            //         const stat_month = stat_date.getMonth()
            //         const stat_year = stat_date.getFullYear()

            //         if (current_month == stat_month && current_year == stat_year) {
            //             this.plan_amount_month += a.totals.total_product_plan
            //             this.fact_amount_month += a.totals.total_product_fact
            //             this.dpf_amount_month += a.totals.dpf
            //         }
            //     })
                
            //     this.percent_amount_month +=  this.fact_amount_month / this.plan_amount_month  * 100
            // }

            console.log(arr)
            return arr
        },
    },

    methods: {
        ...mapActions(['load_archive', 'authenticate', 'open_statistic']),

        // select_archive(archives, id = null){
        //     let ars = []
        //     if(id){
        //         ars.push()
        //     } else {
        //         ars.push(archives.find((a,index) => index == archives.length - 1))
        //     }

        //     console.log(ars, 'arssssssssss');
        //     return ars
        // },
        // set_statistic_id(_id) {
        //     // this.select_archive(this.get_archive, _id)
        //     this.filter();
        // },
        open(_id) {
            this.open_statistic({ _id })
        },
        formated_date(date) {
            return new Date(date).toLocaleDateString('ru-RU')
        },
        nl2br(item) {
            return (item + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2')
        },
        filter(stat) {
            const parse_stat = JSON.parse(JSON.stringify(stat))
            this.product_plan = parse_stat.totals.total_product_plan
            this.product_fact = parse_stat.totals.total_product_fact
            this.DPF = parse_stat.totals.dpf
            this.percent = parse_stat.totals.percent
            return false
            // if (parse_stat) {
            //     stat.groups.forEach((group) => {
            //         group.products.forEach((product) => {
            //             if (group.including) {
            //                 this.product_plan += product.plan
            //                 this.product_fact += product.fact
            //             }

            //             if (product.ratio != 0) this.DPF += product.ratio * 1 * product.fact

            //             product.accessories.forEach((accessory) => {
            //                 //    console.log(accessory, 'acc');

            //                 if (!this.acces.length) {
            //                     this.acces.push(JSON.parse(JSON.stringify(accessory)))
            //                 } else {
            //                     const ran = this.acces.find((acc) => acc._id == accessory._id)
            //                     if (ran) {
            //                         ran.plan += accessory.plan
            //                         ran.fact += accessory.fact
            //                     } else {
            //                         this.acces.push(JSON.parse(JSON.stringify(accessory)))
            //                     }
            //                 }
            //             })
            //         })
            //     })
            // }
            // // this.DPF += this.product_fact * 10;

            // // console.log(this.DPF);
            // return false
        },
        check_date(stats) {
            stats.forEach((stat, index) => {
                if (
                    stat.date ==
                    this.stat_date.toLocaleDateString('ru-RU').replace(/\./g, '-').split('-').reverse().join('-')
                ) {
                    this.selectedTab = index
                }
            })

            return stats
        },
    },
}
</script>

<style scoped>
.supply {
    margin: auto;
}

.fact {
    font-size: 32px;
}

.fact--red {
    color: red;
}

.fact--green {
    color: green;
}

.plan {
    font-size: 22px;
}

img {
    width: 100px;
}

.d-flex {
    display: flex;
}

.align-items-center {
    align-items: center;
}

.justify-space-between {
    justify-content: space-between;
}

.statistic {
    padding: 10px;
    display: flex;
}

.products {
    flex: 3;
}

.products h2 {
    text-align: center;
    margin-bottom: 20px;
}

.totals {
    flex: 1;
    border: 1px solid #ccc;
    border-radius: 6px;
}

.totals h2 {
    text-align: center;
    margin-bottom: 20px;
}

.products_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.products_list .item {
    width: 31%;
    border-radius: 6px;
    margin-bottom: 10px;
    border: 1px solid #ececec;
    padding: 10px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.component {
    display: flex;
    align-items: center;
}

.component img {
    object-fit: contain;
    max-height: 100px;
}

.name {
    text-transform: uppercase;
}

.total_accessory_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.total_accessory {
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 48%;
    margin-bottom: 10px;
    padding: 10px;
}

.total_item {
    padding: 5px 10px;
}

.news {
    display: flex;
    align-items: center;
}

.news img {
    object-fit: contain;
    max-height: 200px;
    max-width: 200px;
}
</style>